import React, { useState } from 'react';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { BiCopy } from 'react-icons/bi';
import './Navbar.css';

function Navbar({
  onShowTour,
  selectedMaintenance,
  buildingName,
  buildingId,
  isRegional = false,
  isCorporate = false,
  userObj = {},
  title
}) {
  const [showCopied, setShowCopied] = useState(false);

  const endDate = selectedMaintenance?.endDate || "N/A";

  const managementCompany = userObj.management_company || "";

  // Define URLs based on user type. unit-access replaces unit-lookup: it takes
  // the Issue Number off the yellow notice rather than a unit number, so the
  // link can be posted in a lobby without exposing every suite in the building.
  const portalLink = `https://hudsonhvac.ca/unit-access?id=${buildingId || ''}`;

  let signupLink = 'https://hudsonhvac.ca/signup';
  if (managementCompany === "DEL Property Management") {
    signupLink += '?pm=del';
  }

  const linkToCopy = isRegional ? signupLink : portalLink;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text:", err);
      });
  };

  function handleLogout() {
    localStorage.removeItem('managerToken');
    localStorage.removeItem('managerUser');
    localStorage.removeItem('hasDoneInitialRedirect');
    window.location.href = '/login';
  }

  return (
    <div className="navbar-dark-bg" style={{ position: 'relative' }}>
      {showCopied && (
        <Alert
          variant="success"
          style={{
            position: 'absolute',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            margin: 0,
            padding: '0.5rem 1rem',
          }}
        >
          <strong>Link copied to clipboard!</strong>
        </Alert>
      )}

      <Container fluid>
        <Row className="align-items-center navbar-top-row">
          <Col xs={6} className="navbar-left-col">
            {(!isCorporate) && (
              <img
                src="https://hudsonhvac.ca/images/logo-w.png"
                alt="Hudson"
                className="hudson-logo"
              />
            )}
          </Col>

          <Col xs={6} className="text-end d-flex justify-content-end align-items-center">
            
            {/* Link & Copy button */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                marginRight: '2rem',
              }}
            >
              <Button
              
                variant="link"
                style={{
                  textDecoration: 'none',
                  color: '#fff',
                  fontSize: '1rem',
                  padding: 0,
                }}
                onClick={() => window.open(linkToCopy, '_blank')}
              >
                <div data-tour="resident-portal">
                <span
                  className="d-none d-md-inline"
                  style={{ textDecoration: 'underline', fontWeight: 600 }}
                >
                  {isRegional ? 'Building Signup Link' : 'Resident Portal Link'}
                </span>
                </div>
              </Button>

              <Button
                variant="link"
                style={{ textDecoration: 'none', color: '#fff', padding: 0 }}
                onClick={copyToClipboard}
              >
                <BiCopy style={{ fontSize: '1.3rem' }} />
              </Button>
            </div>

            {/* Tour Button */}
            <Button
              className="tour-button"
              variant="light"
              style={{ marginRight: '1rem' }}
              onClick={onShowTour}
            >
              ?
            </Button>

            {/* Logout */}
            <Button
              variant="light"
              className="logout-button"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Col>
        </Row>

        <Row className="mt-5 position-relative navbar-building-row">
          {isCorporate ? (
            <Col md={12}>
              <div className="navbar-building-label">Company</div>
              <h2 className="navbar-building-title">{title || 'Hudson Overview'}</h2>
            </Col>
          ) : isRegional ? (
            <Col md={12}>
              <div className="navbar-building-label">{managementCompany}</div>
              <h2 className="navbar-building-title">District Manager Portal</h2>
            </Col>
          ) : (
            <>
              <Col md={6}>
                <div className="navbar-building-label">Building</div>
                <h2 className="navbar-building-title">{buildingName}</h2>
              </Col>
              {/* Optionally show other columns (like Maintenance Date) if desired */}
            </>
          )}
        </Row>

      </Container>
    </div>
  );
}

export default Navbar;
